import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-payment-purchase-record',
  templateUrl: './payment-purchase-record.component.html',
  styleUrls: ['./payment-purchase-record.component.scss']
})
export class PaymentPurchaseRecordComponent implements OnInit {
  payment:any = 0
  apisub:Subscription
  constructor(
    private ls: LoaderServiceService,
    @Inject(MAT_DIALOG_DATA) public parentdata:any,
    private apiservice: ApiService,
    private activemodal:MatDialogRef<PaymentPurchaseRecordComponent>
  ) { 
    this.apisub = this.apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_RECORD_PURCHASE_PAYMENT){
        if(resdata.result){
          this.activemodal.close({msg:'success'})
        }
      }
    })
  }

  ngOnInit(): void {
    this.payment = this.parentdata.data.amount_due
  }

  recordPayment(){
    let obj = {
      "entity_hash": this.parentdata.data.entity_hash_id,
      "hash_id": this.parentdata.data.purchase_hash_id,
      "payment_amount": this.payment,
      "created_by": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
    }

    console.log(obj);
    this.ls.showLoader = true
    this.apiservice.recordPurchasePayment(obj)

    
  }

}
